import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    FieldType
} from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ShComplexInputFieldComponent } from '../complex-input-field/complex-input-field.component';

@Component({
    selector: 'sh-map-field',
    templateUrl: '../complex-map-input-field/complex-map-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShMapInputFieldComponent extends ShComplexInputFieldComponent {
    protected override type: FieldType = FieldType.MapField;

    // Exactly same as ComplexMapField, but with less complex subfields
}
